import React from 'react'
import ReactDom from 'react-dom'
import App from './app'
import './styles/materialize/css/materialize.css'
import './styles/font-awesome/css/font-awesome.min.css'
import './styles/reset.css'



ReactDom.render(<App />, document.getElementById("root"))